import React from 'react';

export default function DetailsRow(props) {
    return (
        <div className="form-group row">
            <label
                className="col-sm-2 col-form-label"
            >{props.lable}
            </label>
            <div className="col-sm-10 col-form-label">
                <span>{props.value}</span>
            </div>
        </div>
    );
}
